import Image from './components/molecules/Image';
import Text from './components/molecules/Text';
import DropdownToggler from './components/organisms/SearchHero/partials/DropdownToggler';
import ShareBtns from './components/molecules/ShareBtns';
import BreakpointDetector from '~/helpers/BreakpointDetector';
import { BreakpointContext } from '~/helpers/BreakpointDetector/BreakpointContext';
import UrlContext from '~/helpers/UrlContext';
import getSpacing from '~/helpers/getSpacing';
import EditorNav from './components/organisms/EditorNav';
import BackToTopBtn from './components/atoms/BackToTopBtn';
import EditButton from './components/atoms/EditButton';
import HeadWrapper from '~/head/HeadWrapper';
import FooterBig from './components/organisms/FooterBig';
import SocialMediaButtons from './components/organisms/FooterBig/partials/SocialMediaButtons';
import Breadcrumb from './components/molecules/Breadcrumb';
import EventOverviewSearch from './components/molecules/EventOverviewSearch';
import jobSearchApi from '~/api/job-search';
import jobAlertApi from '~/api/job-alert';
import Pagination from './components/atoms/Pagination';
import Col from '~/grid/Col';
import SearchFlags from './components/molecules/SearchFlags';
import JobAlert from './components/molecules/JobAlert';
import Container from '~/grid/Container';
import CmsElmWrapper from './components/organisms/CmsElmWrapper';
import DisplayToggleWrapper from './components/organisms/DisplayToggleWrapper';
import AnchorDiv from './components/atoms/AnchorDiv/AnchorDiv';
import {
  jobAlertKey,
  jobSearchKey,
} from './components/organisms/SearchHero/partials/SearchCtas';
import fetchTerms from '~/api/helpers/fetchTerms';
import fetchJobSearchResults from '~/api/helpers/fetchJobSearchResults';
import buildAuthorizationHeader from '~/api/helpers/buildAuthorizationHeader';
import createJobSearchParams from '~/api/helpers/createJobSearchParams';
import fetchGeoapifySuggestions from './components/organisms/SearchHero/helpers/fetchGeoapifySuggestions';
import {
  Headline400Skin,
  Headline500Skin,
  Headline600Skin,
  Headline700Skin,
  Headline800Skin,
} from './components/atoms/Headline/HeadlineSkins';
import Headline, { HeadlineLevel } from './components/atoms/Headline/Headline';
import CTA from './components/atoms/CTA';
import { CTAIconPosition, CTATag } from './components/atoms/CTA/CTA.constants';
import SLOTS_MAP from '~/maps/slots.map';
import PageTypeContext from '~/helpers/PageTypeContext';
import ExtendedGridWrapper from './components/organisms/ExtendedGridWrapper';
import {
  IconBasic,
  Input,
} from './components/organisms/SearchHero/partials/SearchInputsBasicCSS';
import ToastMessage from './components/atoms/ToastMessage';
import getImageProperties from '~/helpers/getImageProperties';
import GoogleMap from './components/molecules/GoogleMap/GoogleMap';
import { LanguageContext } from '~/helpers/LanguageContext';
import AutocompleteFlyout from './components/organisms/SearchHero/partials/AutocompleteFlyout';
import Modal from './components/atoms/Modal';
import StatusIcon from './components/atoms/StatusIcon';
import getCookie, { GIJP_AUTH_COOKIE } from '~/helpers/Cookies/getCookie';
import setCookie from '~/helpers/Cookies/setCookie';
import DeepLSwitcher from './components/molecules/DeepLSwitcher';
import SharedContentSlot from './components/organisms/Contact/partials/SharedContentSlot.JobDetail';
import ShareBtnsDetailPage from './components/organisms/Contact/partials/ShareBtns.JobDetail';
import ContentHubTeaser from './components/organisms/ContentHubTeaser/ContentHubTeaser';
import Overview from './components/organisms/Contact/partials/Overview.JobDetail';
import Description from './components/organisms/Contact/partials/Description.JobDetail';
import Notification from './components/atoms/Notification';
import { getClientConfig } from '~/config/getClientConfig';
import getHeadingTag from '~/helpers/renderer/helpers/getHeadingTag';
import getSeparatorSpacing from '~/helpers/renderer/helpers/getSeparatorSpacing';
import Spacer from './components/molecules/Spacer';
import { IconMap } from './components/atoms/Icon/helpers/iconMap';
import IconCookieShield from '~/assets/CookieShield/IconCookieShield';
import Autotranslation from '~/assets/icons/AutoTranslation';
import Delete from '~/assets/icons/Delete';
import Edit from '~/assets/icons/Edit';
import StatusDraft from '~/assets/icons/StatusDraft';
import StatusInfected from '~/assets/icons/StatusInfected';
import StatusPending from '~/assets/icons/StatusPending';
import StatusPublished from '~/assets/icons/StatusPublished';
import StatusUnpublished from '~/assets/icons/StatusUnpublished';
import CompanyFreseniusHSVamed from './components/atoms/CompanyLogo/logos/CompanyFreseniusHSVamed';
import CompanyLogoCuralie from './components/atoms/CompanyLogo/logos/CompanyLogoCuralie';
import CompanyLogoFDT from './components/atoms/CompanyLogo/logos/CompanyLogoFDT';
import CompanyLogoFMC from './components/atoms/CompanyLogo/logos/CompanyLogoFMC';
import CompanyLogoFSE from './components/atoms/CompanyLogo/logos/CompanyLogoFSE';
import CompanyLogoFSEUppercase from './components/atoms/CompanyLogo/logos/CompanyLogoFSEUppercase';
import CompanyLogoFreseniusManual from './components/atoms/CompanyLogo/logos/CompanyLogoFreseniusManual';
import CompanyLogoGIJPFooter from './components/atoms/CompanyLogo/logos/CompanyLogoGIJPFooter';
import CompanyLogoGIJPLarge from './components/atoms/CompanyLogo/logos/CompanyLogoGIJPLarge';
import CompanyLogoGIJPMobile from './components/atoms/CompanyLogo/logos/CompanyLogoGIJPMobile';
import CompanyLogoHelios from './components/atoms/CompanyLogo/logos/CompanyLogoHelios';
import CompanyLogoKabi from './components/atoms/CompanyLogo/logos/CompanyLogoKabi';
import CompanyLogoMeditec from './components/atoms/CompanyLogo/logos/CompanyLogoMeditec';
import CompanyLogoNephrocare from './components/atoms/CompanyLogo/logos/CompanyLogoNephrocare';
import CompanyLogoQuironPrevencion from './components/atoms/CompanyLogo/logos/CompanyLogoQuironPrevencion';
import CompanyLogoQuironSalud from './components/atoms/CompanyLogo/logos/CompanyLogoQuironSalud';
import CompanyLogoVamed from './components/atoms/CompanyLogo/logos/CompanyLogoVamed';
import { CopyStandard, Copytext } from './components/atoms/Copytext';
import { CopyTextBasicStyling } from './components/atoms/Copytext/Copytext.styles';
import Heading from './components/atoms/Heading';
import Icon from './components/atoms/Icon';
import {
  ContainerLargeBgColor,
  ContainerLargeType,
} from './components/molecules/ContainerLarge/ContainerLarge.helpers';
import { gridGutter, mq } from '~/styles/grid';
import StylesWrapper from '~/styles/StylesWrapper';

const { theme: defaultTheme } = getClientConfig();

export {
  CompanyLogoCuralie,
  CompanyLogoFDT,
  CompanyLogoFMC,
  CompanyLogoFreseniusManual,
  CompanyLogoFSE,
  CompanyLogoFSEUppercase,
  CompanyLogoGIJPFooter,
  CompanyLogoGIJPLarge,
  CompanyLogoGIJPMobile,
  CompanyLogoHelios,
  CompanyLogoKabi,
  CompanyLogoMeditec,
  CompanyLogoNephrocare,
  CompanyLogoQuironPrevencion,
  CompanyLogoQuironSalud,
  CompanyLogoVamed,
  CompanyFreseniusHSVamed,
  StatusUnpublished,
  StatusPublished,
  StatusPending,
  StatusInfected,
  StatusDraft,
  Edit,
  Delete,
  Autotranslation,
  IconCookieShield,
  IconMap,
  gridGutter,
  Col,
  StylesWrapper,
  BreakpointDetector,
  BreakpointContext,
  Breadcrumb,
  UrlContext,
  DropdownToggler,
  AutocompleteFlyout,
  Copytext,
  defaultTheme,
  FooterBig,
  SocialMediaButtons,
  CopyStandard,
  ContainerLargeBgColor,
  ContainerLargeType,
  Heading,
  Icon,
  Image,
  Text,
  ShareBtns,
  getSpacing,
  EditorNav,
  BackToTopBtn,
  EditButton,
  HeadWrapper,
  EventOverviewSearch,
  jobSearchApi,
  Pagination,
  SearchFlags,
  JobAlert,
  Container,
  CmsElmWrapper,
  DisplayToggleWrapper,
  AnchorDiv,
  jobAlertKey,
  jobSearchKey,
  fetchTerms,
  fetchJobSearchResults,
  buildAuthorizationHeader,
  createJobSearchParams,
  fetchGeoapifySuggestions,
  jobAlertApi,
  CopyTextBasicStyling,
  Headline700Skin,
  Headline800Skin,
  Headline600Skin,
  Headline500Skin,
  Headline400Skin,
  HeadlineLevel,
  Headline,
  CTA,
  mq,
  CTAIconPosition,
  StatusIcon,
  SLOTS_MAP,
  PageTypeContext,
  CTATag,
  ExtendedGridWrapper,
  IconBasic,
  Input,
  ToastMessage,
  getImageProperties,
  GoogleMap,
  LanguageContext,
  Modal,
  getCookie,
  GIJP_AUTH_COOKIE,
  setCookie,
  DeepLSwitcher,
  SharedContentSlot,
  ShareBtnsDetailPage,
  Overview,
  Description,
  Notification,
  ContentHubTeaser,
  getHeadingTag,
  Spacer,
  getSeparatorSpacing,
};
